function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const MAIN_PRODUCT_ACCORDION_ANIMATION_DURATION = 240;
const MAIN_PRODUCT_ACCORDION_ANIMATION_EASING = 'ease';

function setupMainProductAccordionAnimations() {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.main-product-pdp .product__accordion details').forEach((detailsElement) => {
    if (detailsElement.dataset.accordionAnimated === 'true') return;

    const summaryElement = detailsElement.querySelector('summary');
    const contentElement = summaryElement?.nextElementSibling;
    if (!summaryElement || !contentElement) return;

    detailsElement.dataset.accordionAnimated = 'true';

    const clearAnimationStyles = () => {
      contentElement.style.height = '';
      contentElement.style.overflow = '';
      contentElement.style.transition = '';
      detailsElement.removeAttribute('data-accordion-animating');
    };

    summaryElement.addEventListener('click', (event) => {
      if (prefersReducedMotion || detailsElement.dataset.accordionAnimating === 'true') return;

      event.preventDefault();
      detailsElement.dataset.accordionAnimating = 'true';

      if (detailsElement.open) {
        const startHeight = contentElement.offsetHeight;
        contentElement.style.height = `${startHeight}px`;
        contentElement.style.overflow = 'hidden';
        contentElement.offsetHeight;
        contentElement.style.transition = `height ${MAIN_PRODUCT_ACCORDION_ANIMATION_DURATION}ms ${MAIN_PRODUCT_ACCORDION_ANIMATION_EASING}`;
        contentElement.style.height = '0px';

        const closeAnimationDone = () => {
          contentElement.removeEventListener('transitionend', closeAnimationDone);
          detailsElement.removeAttribute('open');
          clearAnimationStyles();
        };

        contentElement.addEventListener('transitionend', closeAnimationDone);
        return;
      }

      detailsElement.setAttribute('open', '');
      contentElement.style.height = '0px';
      contentElement.style.overflow = 'hidden';
      contentElement.offsetHeight;
      contentElement.style.transition = `height ${MAIN_PRODUCT_ACCORDION_ANIMATION_DURATION}ms ${MAIN_PRODUCT_ACCORDION_ANIMATION_EASING}`;
      contentElement.style.height = `${contentElement.scrollHeight}px`;

      const openAnimationDone = () => {
        contentElement.removeEventListener('transitionend', openAnimationDone);
        clearAnimationStyles();
      };

      contentElement.addEventListener('transitionend', openAnimationDone);
    });
  });
}

setupMainProductAccordionAnimations();

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

const bodyScrollLockState = {
  lockedBy: new Set(),
  scrollY: 0,
};

function lockBodyScroll(source = 'default') {
  bodyScrollLockState.lockedBy.add(source);
  if (bodyScrollLockState.lockedBy.size > 1) return;

  bodyScrollLockState.scrollY = window.scrollY || window.pageYOffset || 0;
  document.documentElement.classList.add('is-scroll-locked');
  document.body.classList.add('is-scroll-locked');
  document.body.style.position = 'fixed';
  document.body.style.top = `-${bodyScrollLockState.scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
  document.body.style.overflow = 'hidden';
}

function unlockBodyScroll(source = 'default') {
  bodyScrollLockState.lockedBy.delete(source);
  if (bodyScrollLockState.lockedBy.size > 0) return;

  document.documentElement.classList.remove('is-scroll-locked');
  document.body.classList.remove('is-scroll-locked');
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  document.body.style.overflow = '';
  window.scrollTo(0, bodyScrollLockState.scrollY || 0);
}

window.lockBodyScroll = lockBodyScroll;
window.unlockBodyScroll = unlockBodyScroll;

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.userEngaged = false;
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    this.videoSoundToggleButton = this.querySelector('[data-video-sound-toggle]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
    if (this.videoSoundToggleButton) {
      this.videoSoundToggleButton.addEventListener('click', this.toggleVideoSound.bind(this));
    }
    this.setupVideoPauseObservers();
  }

  setupVideoPlayStateListeners(video) {
    video.addEventListener('play', () => {
      if (this.videoSoundToggleButton) this.videoSoundToggleButton.classList.remove('hidden');
      this.updateVideoSoundToggle(video);
    });
    video.addEventListener('pause', () => {
      if (this.videoSoundToggleButton) this.videoSoundToggleButton.classList.add('hidden');
    });
  }

  setupVideoPauseObservers() {
    const slide = this.closest('.product__media-item[data-media-id]') || this.closest('[data-media-id]');

    // Pause when scrolled out of viewport, resume when back in
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = this.querySelector('video');
          if (!video) return;

          const gallery = this.closest('media-gallery');
          if (gallery?.isTransitioning) return;

          if (entry.isIntersecting) {
            if (this.userEngaged && slide?.classList.contains('is-active')) {
              video.play().catch(() => {});
            }
          } else {
            this.resetContent();
          }
        });
      },
      { threshold: 0.2 }
    );
    this.intersectionObserver.observe(this);

    // Pause when slide becomes inactive (slider context)
    if (slide && slide !== this) {
      this.slideObserver = new MutationObserver(() => {
        if (!slide.classList.contains('is-active') || slide.hidden) {
          const gallery = this.closest('media-gallery');
          if (gallery?.isTransitioning) return;

          this.resetContent();
        }
      });
      this.slideObserver.observe(slide, { attributes: true, attributeFilter: ['class', 'hidden'] });
    }
  }

  resetContent() {
    this.querySelectorAll(':scope > video, :scope > iframe').forEach((mediaElement) => {
      if (mediaElement.tagName === 'VIDEO') {
        mediaElement.pause();
        mediaElement.currentTime = 0;
      }
      mediaElement.remove();
    });

    this.removeAttribute('loaded');
    this.userEngaged = false;
    this.updateVideoSoundToggle(null);
  }

  loadContent(focus = true) {
    this.userEngaged = true;
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      this.setAttribute('loaded', true);
      if (focus) deferredElement.focus();
      if (deferredElement && deferredElement.tagName === 'VIDEO') {
        this.setupVideoPlayStateListeners(deferredElement);
        deferredElement.play().catch(() => {});
      }
      this.updateVideoSoundToggle(deferredElement);
      return;
    }

    const videoElement = this.querySelector('video');
    if (videoElement) {
      videoElement.play().catch(() => {});
    }
    this.updateVideoSoundToggle(videoElement);
  }

  updateVideoSoundToggle(mediaElement) {
    if (!this.videoSoundToggleButton) return;
    const video = mediaElement && mediaElement.tagName === 'VIDEO' ? mediaElement : this.querySelector('video');
    if (!video) {
      this.videoSoundToggleButton.classList.add('hidden');
      return;
    }

    if (video.paused) this.videoSoundToggleButton.classList.add('hidden');
    const mutedLabel = this.videoSoundToggleButton.dataset.mutedLabel || 'Unmute';
    const unmutedLabel = this.videoSoundToggleButton.dataset.unmutedLabel || 'Mute';
    const isMuted = video.muted;
    this.videoSoundToggleButton.setAttribute('aria-label', isMuted ? mutedLabel : unmutedLabel);
    this.videoSoundToggleButton.setAttribute('aria-pressed', String(!isMuted));

    const mutedIcon = this.videoSoundToggleButton.querySelector('.deferred-media__sound-icon--muted');
    const unmutedIcon = this.videoSoundToggleButton.querySelector('.deferred-media__sound-icon--unmuted');
    if (mutedIcon) mutedIcon.classList.toggle('hidden', !isMuted);
    if (unmutedIcon) unmutedIcon.classList.toggle('hidden', isMuted);
  }

  toggleVideoSound() {
    const video = this.querySelector('video');
    if (!video) return;
    video.muted = !video.muted;
    this.updateVideoSoundToggle(video);
  }
}

customElements.define('deferred-media', DeferredMedia);


class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton || !this.prevButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton?.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton?.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton?.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton?.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton?.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.initialColorOptions = new Map();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    this.captureInitialColorOptions();
    this.updateOptions();
    this.updateMasterId();
    this.queueMediaUpdate();
    this.syncRenderedVariant();
  }

  // The server-rendered variant can differ from what the picker resolves when option values are
  // withheld from the picker — e.g. Sample sizes are stripped out when the Get Sample button is on,
  // so a product landed on with the Sample variant selected must fall back to the Yard variant.
  syncRenderedVariant() {
    if (this.parentElement?.closest('variant-selects, variant-radios')) return;

    const samplesWithheld = this.applyFallbackNonSampleSize();
    this.updateOptions();
    this.updateMasterId();
    if (!this.currentVariant) return;

    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const renderedVariantId = productForm?.querySelector('input[name="id"]')?.value;
    const variantChanged = !renderedVariantId || String(renderedVariantId) !== String(this.currentVariant.id);

    if (!samplesWithheld && !variantChanged) return;

    this.updateURL();
    this.updateVariantInput();
    this.updatePickupAvailability();
    this.updateShareUrl();
    this.updateMedia();
    if (variantChanged) this.renderProductInfo();
  }

  getSizeOptionIndexFromVariants() {
    const variants = this.getVariantData();
    const optionCount = variants[0]?.options?.length || 0;
    for (let index = 0; index < optionCount; index += 1) {
      if (variants.some((variant) => /sample/i.test(String(variant.options?.[index] || '')))) {
        return index;
      }
    }
    return -1;
  }

  isSizeOptionName(name) {
    return /\bsize\b/i.test(String(name || ''));
  }

  findSizeOptionControl() {
    const fieldsets = Array.from(this.querySelectorAll(':scope > fieldset'));
    for (const fieldset of fieldsets) {
      const input = fieldset.querySelector('input[type="radio"]');
      const legend = fieldset.querySelector('legend')?.textContent || '';
      if (this.isSizeOptionName(this.getControlOptionName(input)) || this.isSizeOptionName(legend)) {
        return { type: 'radio', element: fieldset };
      }
    }

    const selects = Array.from(this.querySelectorAll('select')).filter(
      (select) => !select.closest('.material-hidden-slc')
    );
    for (const select of selects) {
      if (this.isSizeOptionName(this.getControlOptionName(select))) {
        return { type: 'select', element: select };
      }
    }

    return null;
  }

  getControlValues(control) {
    if (!control?.element) return [];
    if (control.type === 'radio') {
      return Array.from(control.element.querySelectorAll('input[type="radio"]')).map((input) => input.value);
    }
    return Array.from(control.element.options)
      .map((option) => option.value)
      .filter(Boolean);
  }

  getControlSelectedValue(control) {
    if (!control?.element) return '';
    if (control.type === 'radio') {
      return control.element.querySelector('input[type="radio"]:checked')?.value || '';
    }
    return control.element.value || '';
  }

  setControlSelectedValue(control, value) {
    if (!control?.element || !value) return;
    if (control.type === 'radio') {
      const input = Array.from(control.element.querySelectorAll('input[type="radio"]')).find(
        (radio) => radio.value === value
      );
      if (input && !input.checked) input.checked = true;
      return;
    }
    if (control.element.value !== value) control.element.value = value;
  }

  applyFallbackNonSampleSize() {
    const sizeIndex = this.getSizeOptionIndexFromVariants();
    if (sizeIndex < 0) return false;

    const sampleValues = this.getVariantData()
      .map((variant) => String(variant.options?.[sizeIndex] || ''))
      .filter((value) => /sample/i.test(value));
    if (!sampleValues.length) return false;

    const control = this.findSizeOptionControl();
    if (!control) return false;

    const pickerValues = this.getControlValues(control);
    const samplesWithheld = sampleValues.some((value) => !pickerValues.includes(value));
    if (!samplesWithheld) return false;

    const selected = this.getControlSelectedValue(control);
    if (selected && !/sample/i.test(selected)) return true;

    const nonSampleValues = pickerValues.filter((value) => value && !/sample/i.test(value));
    const preferred = nonSampleValues.find((value) => /yard/i.test(value)) || nonSampleValues[0];
    if (preferred) this.setControlSelectedValue(control, preferred);

    return true;
  }

  queueMediaUpdate() {
    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    const needsColorFilter = mediaGallery?.dataset.hideVariants === 'true';

    const runUpdate = () => this.updateMedia();
    const mediaGalleryReady = customElements.whenDefined('media-gallery');
    const colorFilterReady = needsColorFilter ? this.waitForVariantMediaFilter() : Promise.resolve();

    Promise.all([mediaGalleryReady, colorFilterReady]).then(runUpdate);
  }

  waitForVariantMediaFilter() {
    if (window.VariantMediaFilter) return Promise.resolve();

    return new Promise((resolve) => {
      const finish = () => resolve();

      const tryAttach = () => {
        const existingScript = document.querySelector('script[src*="variant-media-filter"]');
        if (!existingScript) return false;

        if (window.VariantMediaFilter) {
          finish();
          return true;
        }

        existingScript.addEventListener('load', finish, { once: true });
        existingScript.addEventListener('error', finish, { once: true });
        return true;
      };

      if (tryAttach()) return;

      document.addEventListener('DOMContentLoaded', () => {
        if (window.VariantMediaFilter) {
          finish();
          return;
        }
        if (!tryAttach()) finish();
      }, { once: true });
    });
  }

  captureInitialColorOptions() {
    this.initialColorOptions = new Map();

    this.querySelectorAll('fieldset').forEach((fieldset, index) => {
      if (!this.isColorOptionFieldset(fieldset)) return;
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked?.value) this.initialColorOptions.set(index, checked.value);
    });

    this.querySelectorAll('select').forEach((select, index) => {
      if (!this.isColorSelect(select)) return;
      if (select.value) this.initialColorOptions.set(index, select.value);
    });
  }

  isColorOptionFieldset(fieldset) {
    const legendText = fieldset.querySelector('legend')?.textContent?.trim().toLowerCase() || '';
    return legendText.includes('color') || legendText.includes('colour');
  }

  isColorSelect(select) {
    return select.classList.contains('color-select-field') || /color|colour/i.test(select.name || '');
  }

  isProductColorOptionName(optionName) {
    return /^(color|colour)$/i.test((optionName || '').trim());
  }

  // Broader than product Color — includes Frame Color and similar swatch options used for media.
  isMediaColorOptionName(optionName) {
    return /color|colour/i.test((optionName || '').trim());
  }

  isMediaColorFieldset(fieldset) {
    if (!fieldset) return false;
    if (
      fieldset.classList.contains('product-form__input--swatches') ||
      fieldset.classList.contains('product-form__input--frame-swatches')
    ) {
      return true;
    }
    if (this.isColorOptionFieldset(fieldset)) return true;

    const firstInput = fieldset.querySelector('input[type="radio"]');
    return Boolean(firstInput && this.isMediaColorOptionName(this.getControlOptionName(firstInput)));
  }

  getControlOptionName(control) {
    const name = control?.getAttribute('name') || '';
    const optionMatch = name.match(/^options\[(.*)\]$/);
    return optionMatch ? optionMatch[1] : name;
  }

  getSelectedProductColorIndex() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    for (const fieldset of fieldsets) {
      const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      const firstInput = inputs[0];
      if (!firstInput || !this.isProductColorOptionName(this.getControlOptionName(firstInput))) continue;

      const checkedInput = inputs.find((input) => input.checked);
      if (!checkedInput) return null;

      const checkedIndex = inputs.findIndex((input) => input.value === checkedInput.value);
      return checkedIndex > -1 ? checkedIndex + 1 : null;
    }

    const selects = Array.from(this.querySelectorAll('select'));
    for (const select of selects) {
      if (!this.isProductColorOptionName(this.getControlOptionName(select))) continue;
      if (!select.value) return null;

      const colorOptions = Array.from(select.options).filter((option) => option.value);
      const selectedIndex = colorOptions.findIndex((option) => option.value === select.value);
      return selectedIndex > -1 ? selectedIndex + 1 : null;
    }

    return null;
  }

  getProductColorOptionIndex() {
    const selects = Array.from(this.querySelectorAll('select'));
    if (selects.length) {
      const selectIndex = selects.findIndex((select) => {
        return this.isProductColorOptionName(this.getControlOptionName(select));
      });
      if (selectIndex > -1) return selectIndex;
    }

    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    return fieldsets.findIndex((fieldset) => {
      const firstInput = fieldset.querySelector('input[type="radio"]');
      return firstInput && this.isProductColorOptionName(this.getControlOptionName(firstInput));
    });
  }

  getMediaColorOptionIndex() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const swatchIndex = fieldsets.findIndex((fieldset) => this.isMediaColorFieldset(fieldset));
    if (swatchIndex > -1) return swatchIndex;

    const selects = Array.from(this.querySelectorAll('select'));
    if (selects.length) {
      const selectIndex = selects.findIndex((select) => {
        return this.isMediaColorOptionName(this.getControlOptionName(select)) || this.isColorSelect(select);
      });
      if (selectIndex > -1) return selectIndex;
    }

    return fieldsets.findIndex((fieldset) => {
      const firstInput = fieldset.querySelector('input[type="radio"]');
      return firstInput && this.isMediaColorOptionName(this.getControlOptionName(firstInput));
    });
  }

  hasProductColorOption() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const hasColorFieldset = fieldsets.some((fieldset) => {
      const firstInput = fieldset.querySelector('input[type="radio"]');
      return firstInput && this.isProductColorOptionName(this.getControlOptionName(firstInput));
    });

    if (hasColorFieldset) return true;

    return Array.from(this.querySelectorAll('select')).some((select) => {
      return this.isProductColorOptionName(this.getControlOptionName(select));
    });
  }

  syncIndexedGalleryMedia(mediaGallery, selectedColorIndex, selectedMediaId = null, filterProductMedia = false) {
    const indexedGalleryItems = Array.from(mediaGallery.querySelectorAll('[data-custom-field-gallery-image][data-gallery-color-index], [data-indexed-gallery-media][data-gallery-color-index]'));
    const productGalleryItems = Array.from(mediaGallery.querySelectorAll('[data-product-gallery-media]:not([data-indexed-gallery-media])'));
    if (!indexedGalleryItems.length && !productGalleryItems.length) return;

    const selectedIndex = selectedColorIndex ? String(selectedColorIndex) : '';
    const keepUnindexedProductMediaVisible = mediaGallery.dataset.galleryOrderColorIndexing === 'true';
    const shouldFilterProductMedia = Boolean(
      !keepUnindexedProductMediaVisible && indexedGalleryItems.length && (selectedMediaId || filterProductMedia)
    );

    const setGalleryItemVisibility = (item, shouldHide) => {
      item.hidden = shouldHide;
      item.style.display = shouldHide ? 'none' : '';
      item.classList.toggle('is-gallery-color-filtered-out', shouldHide);

      if (!shouldHide) return;

      item.classList.remove('is-active');
      item.querySelectorAll('deferred-media').forEach((media) => media.resetContent?.());
      const thumbnailButton = item.querySelector('button[aria-current]');
      if (thumbnailButton) thumbnailButton.removeAttribute('aria-current');
    };

    if (selectedIndex) {
      mediaGallery.dataset.activeGalleryColorIndex = selectedIndex;
    } else {
      delete mediaGallery.dataset.activeGalleryColorIndex;
    }

    indexedGalleryItems.forEach((item) => {
      const shouldHide = Boolean(selectedIndex) && item.dataset.galleryColorIndex !== selectedIndex;
      setGalleryItemVisibility(item, shouldHide);
    });

    productGalleryItems.forEach((item) => {
      const itemMediaId = item.dataset.mediaId || item.dataset.target;
      const shouldHide = shouldFilterProductMedia && itemMediaId !== selectedMediaId;
      setGalleryItemVisibility(item, shouldHide);
    });

    mediaGallery.elements?.viewer?.resetPages?.();
    mediaGallery.elements?.thumbnails?.resetPages?.();
    mediaGallery.syncThumbnailArrowVisibility?.();

    const activeMedia = mediaGallery.elements?.viewer?.querySelector('[data-media-id].is-active:not([hidden])');
    if (activeMedia) return;

    const nextMedia =
      (selectedMediaId && mediaGallery.elements?.viewer?.querySelector(`[data-media-id="${selectedMediaId}"]:not([hidden])`)) ||
      (selectedIndex && mediaGallery.elements?.viewer?.querySelector(`[data-media-id][data-gallery-color-index="${selectedIndex}"]:not([hidden])`)) ||
      mediaGallery.elements?.viewer?.querySelector('[data-media-id]:not([hidden])');

    if (nextMedia && typeof mediaGallery.setActiveMedia === 'function') {
      mediaGallery.setActiveMedia(nextMedia.dataset.mediaId, false);
    }
  }

  isColorOptionIndex(index) {
    if (this.initialColorOptions?.has(index)) return true;

    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    if (fieldsets[index] && this.isColorOptionFieldset(fieldsets[index])) return true;

    const selects = Array.from(this.querySelectorAll('select'));
    return Boolean(selects[index] && this.isColorSelect(selects[index]));
  }

  getOptionsForVariantMatch() {
    if (!this.options) this.updateOptions();

    return this.options.map((value, index) => {
      if (value) return value;
      return this.initialColorOptions?.get(index) || '';
    });
  }

  hasCompletedVariantSelection() {
    if (this.currentVariant) return true;

    const options = this.getOptionsForVariantMatch();
    if (!options.length) return false;

    return this.getVariantData().some((variant) =>
      variant.options.every((option, index) => options[index] === option)
    );
  }

  getVariantFeaturedMediaId(variant) {
    if (!variant) return null;
    return variant.featured_media?.id || variant.featured_image?.id || null;
  }

  getSelectedOrDefaultVariant() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const variantId = productForm?.querySelector('input[name="id"]')?.value;
    if (!variantId) return null;

    return this.getVariantData().find((variant) => String(variant.id) === String(variantId)) || null;
  }

  getFallbackMediaVariantForSelectedColor() {
    const colorOptionIndex = this.getMediaColorOptionIndex();
    if (colorOptionIndex < 0) return null;

    const options = this.getOptionsForVariantMatch();
    const selectedColor = options[colorOptionIndex];
    if (!selectedColor) return null;

    // Include sold-out variants — color swatches must still drive gallery images.
    return this.getVariantData()
      .filter((variant) => {
        return variant.options?.[colorOptionIndex] === selectedColor && this.getVariantFeaturedMediaId(variant);
      })
      .map((variant) => {
        const matchScore = variant.options.reduce((score, option, index) => {
          if (index === colorOptionIndex) return score;
          return options[index] && options[index] === option ? score + 1 : score;
        }, 0);

        return { variant, score: matchScore };
      })
      .sort((a, b) => b.score - a.score)[0]?.variant || null;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateMedia();

    if (!this.currentVariant) {
      if (this.dataset.requireVariantSelect === 'true' && this.hasUnselectedOptions()) {
        this.toggleAddButton(true, this.getSelectRequiredText(), false);
        return;
      }
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  hasUnselectedOptions() {
    const selects = Array.from(this.querySelectorAll('select'));
    if (selects.length) {
      return selects.some((select, index) => {
        if (this.isColorOptionIndex(index)) return false;
        return !select.value;
      });
    }

    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    if (fieldsets.length) {
      return fieldsets.some((fieldset, index) => {
        if (this.isColorOptionIndex(index)) return false;
        return !fieldset.querySelector('input[type="radio"]:checked');
      });
    }

    return false;
  }

  getSelectRequiredText() {
    return this.dataset.selectRequiredLabel || window.variantStrings.unavailable;
  }

  updateMasterId() {
    const options = this.getOptionsForVariantMatch();
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return options[index] === option;
      }).includes(false);
    });
  }

  getMediaVariant({ allowWithoutHideVariants = false } = {}) {
    if (this.currentVariant && this.getVariantFeaturedMediaId(this.currentVariant)) {
      return this.currentVariant;
    }

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (!allowWithoutHideVariants && mediaGallery?.dataset.hideVariants !== 'true') return null;

    if (!this._mediaVariantInitialized) {
      this._mediaVariantInitialized = true;
      const formVariant = this.getSelectedOrDefaultVariant();
      if (formVariant && this.getVariantFeaturedMediaId(formVariant)) return formVariant;
    }

    const options = this.getOptionsForVariantMatch();

    const exactMatch = this.getVariantData().find((variant) => {
      return (
        this.getVariantFeaturedMediaId(variant) &&
        variant.options.every((option, index) => {
          return !options[index] || options[index] === option;
        })
      );
    });
    if (exactMatch) return exactMatch;

    return this.getFallbackMediaVariantForSelectedColor();
  }

  resetIndexedGalleryMediaVisibility(mediaGallery) {
    mediaGallery.querySelectorAll('[data-product-gallery-media], [data-custom-field-gallery-image]').forEach((item) => {
      item.hidden = false;
      item.style.display = '';
      item.classList.remove('is-gallery-color-filtered-out');
    });
  }

  updateMedia() {
    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (!mediaGallery) return;

    if (mediaGallery.dataset.hideVariants === 'true') {
      const primaryPicker =
        window.VariantMediaFilter?.getPrimaryVariantPicker(this.dataset.section) || this;
      window.VariantMediaFilter?.syncFromVariantSelects(primaryPicker, mediaGallery);
      return;
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    mediaGallery.classList.remove('media-gallery--hide-variants-active');
    mediaGallery.classList.remove('media-gallery--color-filter-active');
    modalContent?.classList.remove('product-media-modal__content--hide-variants-active');
    this.resetIndexedGalleryMediaVisibility(mediaGallery);
    window.VariantMediaFilter?.reset?.(mediaGallery, this.dataset.section);

    const primaryPicker =
      window.VariantMediaFilter?.getPrimaryVariantPicker(this.dataset.section) || this;

    // Always resolve gallery media from the selected options, including sold-out
    // variants and Frame Color / swatch picks that don't form a complete match.
    let mediaVariant =
      (primaryPicker.currentVariant &&
        primaryPicker.getVariantFeaturedMediaId?.(primaryPicker.currentVariant) &&
        primaryPicker.currentVariant) ||
      primaryPicker.getMediaVariant?.({ allowWithoutHideVariants: true }) ||
      primaryPicker.getFallbackMediaVariantForSelectedColor?.();

    if (!mediaVariant) return;

    const featuredMediaId = primaryPicker.getVariantFeaturedMediaId(mediaVariant);
    if (!featuredMediaId) return;

    const selectedMediaId = `${this.dataset.section}-${featuredMediaId}`;
    const viewer =
      mediaGallery.elements?.viewer ||
      mediaGallery.querySelector(`#GalleryViewer-${this.dataset.section}`);
    const selectedMedia = viewer?.querySelector(`[data-media-id="${selectedMediaId}"]`);

    if (!selectedMedia || typeof mediaGallery.setActiveMedia !== 'function') return;

    mediaGallery.setActiveMedia(selectedMediaId, true);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const sourceSection = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

        ['price', 'price-mobile'].forEach((prefix) => {
          const destination = document.getElementById(`${prefix}-${this.dataset.section}`);
          if (!destination) return;

          const source = html.getElementById(`${prefix}-${sourceSection}`);
          if (source) destination.innerHTML = source.innerHTML;
          destination.classList.remove('visibility-hidden');
        });

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;

    if (addButton.dataset.pdpAtc !== undefined) {
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) {
          const textEl = addButton.querySelector('.pdp-atc-button__text');
          const priceEl = addButton.querySelector('.pdp-atc-button__price');
          const separatorEl = addButton.querySelector('.pdp-atc-button__separator');
          if (textEl) textEl.textContent = text;
          if (priceEl) priceEl.hidden = true;
          if (separatorEl) separatorEl.hidden = true;
        }
      } else {
        addButton.removeAttribute('disabled');
        addButton.dispatchEvent(new CustomEvent('pdp-atc:refresh', { bubbles: true }));
      }
      if (!modifyClass) return;
      return;
    }

    const addButtonText = addButton.querySelector(':scope > span');
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text && addButtonText) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;

    if (addButton.dataset.pdpAtc !== undefined) {
      const textEl = addButton.querySelector('.pdp-atc-button__text');
      const priceEl = addButton.querySelector('.pdp-atc-button__price');
      const separatorEl = addButton.querySelector('.pdp-atc-button__separator');
      if (textEl) textEl.textContent = window.variantStrings.unavailable;
      if (priceEl) priceEl.hidden = true;
      if (separatorEl) separatorEl.hidden = true;
      if (price) price.classList.add('visibility-hidden');
      return;
    }

    const addButtonText = addButton.querySelector(':scope > span');
    if (addButtonText) addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      return checkedRadio ? checkedRadio.value : '';
    });
    this.updateSwatchLegends();
  }

  updateSwatchLegends() {
    this.querySelectorAll('fieldset.product-form__input--swatches').forEach((fieldset) => {
      const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
      const valueEl = fieldset.querySelector('.variant-swatch-legend__value');
      if (checkedInput && valueEl) valueEl.textContent = this.formatOptionValueLabel(checkedInput.value);
    });
  }

  formatOptionValueLabel(value) {
    if (!value) return '';
    const label = String(value);
    const separatorIndex = label.indexOf('--');
    return separatorIndex === -1 ? label : label.slice(0, separatorIndex).trim();
  }
}

customElements.define('variant-radios', VariantRadios);

(function () {
  function initStickyATC() {
    var sticky = document.querySelector('[data-sticky-atc-bar]');
    if (!sticky) return false;

    var button = sticky.querySelector('[data-sticky-atc-button]');
    if (!button) return false;

    function fixStickyATC() {
      var hidden = sticky.getAttribute('aria-hidden') === 'true';

      if (hidden) {
        button.setAttribute('tabindex', '-1');
      } else {
        button.removeAttribute('tabindex');
      }
    }

    fixStickyATC();

    new MutationObserver(function () {
      fixStickyATC();
    }).observe(sticky, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });

    return true;
  }

  if (!initStickyATC()) {
    var tries = 0;

    var interval = setInterval(function () {
      if (initStickyATC() || ++tries > 60) {
        clearInterval(interval);
      }
    }, 500);
  }
})();
